export default "__VITE_ASSET__CbWBAfX9__"